import { render, staticRenderFns } from "./ExpandIconButton.vue?vue&type=template&id=39c1d712&scoped=true&"
import script from "./ExpandIconButton.vue?vue&type=script&lang=js&"
export * from "./ExpandIconButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandIconButton.vue?vue&type=style&index=0&id=39c1d712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c1d712",
  null
  
)

export default component.exports